export default {
  en: {
    auth: {
      failed: 'These credentials do not match our records.',
      throttle: 'Too many login attempts. Please try again in {seconds} seconds.'
    },
    labels: {
      nav: {
        dashboard: 'Dashboard',
        settings: 'Settings',
        general: 'General',
        accounts: 'Accounts',
        all_roles: 'All Roles',
        my_profile: 'My Profile',
        bank_feed: 'Bank Feed',
        transactions: 'Transactions'
      },
      all_resource: 'All {resource}',
      action_resource: '{action} {resource}',
      view: 'View',
      create: 'Create',
      add: 'Add',
      edit: 'Edit',
      delete: 'Delete',
      assume: 'Assume',
      connect: 'Connect',
      select: 'Select',
      import: 'Import',
      user: 'User | Users',
      record: 'Record | Records',
      client: 'Client | Clients',
      feed: 'Transaction Feed | Transaction Feeds',
      budget: 'Budget | Budgets',
      fund: 'Fund | Funds',
      fund_balance: 'Fund Balance | Fund Balances',
      budget_balance: 'Budget Balance | Budget Balances',
      tag: 'Tag | Tags',
      transaction: 'Transaction | Transactions',
      bank_feed: 'Bank Feed | Bank Feeds',
      account_name: 'Account Name',
      active: 'Active',
      anchor_text: 'Anchor Text',
      assign: 'Assign',
      automatic_unit_ordering: 'Automatic Unit Ordering',
      browse: 'Browse',
      choose_file: 'Choose File',
      choose_image: 'Choose Image',
      comments: 'Comments',
      create_discussion: 'Create New Discussion',
      topic: 'Topic',
      client_contacts: 'Contact Information',
      client_global: 'Client Settings',
      client_name: 'Client Name',
      open: 'Open',
      clear: 'Clear',
      content: 'Content',
      create_account: 'Create Account',
      create_client_contact: 'Add Contact Information',
      create_client_global: 'Add Custom Field',
      create_record_type: 'Add Type',
      create_role: 'Add Role',
      create_user: 'Create User',
      date: 'Date',
      destroy: 'Delete',
      destroy_record_type: 'Delete Record Type',
      destroy_role: 'Delete Role',
      destroy_user: 'Delete User',
      destroy_comment: 'Delete Comment',
      discussions: 'Discussions',
      account: 'Account',
      done: 'Done',
      email: 'Email',
      email_address: 'Email Address',
      follow: 'Follow',
      forgot_password: 'Forgot Password',
      label: 'Label',
      manager: 'Manager',
      name: 'Name',
      no: 'No',
      notification_regularity: 'Notification Regularity',
      overview: 'Overview',
      password: 'Password',
      password_confirmation: 'Confirm Password',
      personal_preferences: 'Personal Preferences',
      profile_picture: 'Profile Picture',
      record_type: 'Record Type',
      record_types: 'Record Types',
      report: 'Rprt',
      reporting_name: 'Reporting Label',
      role: 'Role',
      roles: 'Roles',
      settings: 'Settings',
      sign_in: 'Sign In',
      sign_out: 'Sign Out',
      state: 'State',
      submit: 'Submit',
      type: 'Type',
      update: 'Update',
      update_user: 'Edit User',
      url: 'URL',
      yes: 'Yes',
      units: 'Units',
      domains: 'Domains',
      domain: 'Domain',
      balance: 'Balance',
      options_selected: '{count} options selected',
      please_select: 'Please Select...',
      copy: 'Copy',
      alert: 'Alert',
      totals: 'Totals',
      frame: 'Time Frame',
      amount: 'Amount',
      bank: 'Bank',
      starting_amount: 'Starting Amount',
      description: 'Description',
      file: 'File',
      reserved: 'Reserved',
      spent: 'Spent',
      calc_spent: 'Calculated Spend',
      average_spent: 'Avgerage Spend',
      frames: {
        week: 'Weekly',
        month: 'Monthly',
        annual: 'Annually'
      },
      banks: {
        1: 'CBA'
      },
      filters: {
        from_today: 'From Today',
        from_week: 'From This Week',
        from_month: 'From This Month',
        from_quarter: 'From This Quarter',
        from_financial_year: 'From This Financial Year',
        from_year: 'From This Year',
        today: 'Today',
        this_week: 'This Week',
        this_month: 'This Month',
        last_month: 'Last Month',
        this_quarter: 'This Quarter',
        last_quarter: 'Last Quarter',
        this_financial_year: 'This Financial Year',
        last_financial_year: 'Last Financial Year',
        this_year: 'This Year',
        last_year: 'Last Year',
        last_30: 'Last 30 Days',
        last_60: 'Last 60 Days',
        last_90: 'Last 90 Days',
        last_120: 'Last 120 Days',
        last_6: 'Last 6 Months',
        last_9: 'Last 9 Months'
      }
    },
    messages: {
      initial_load: "We're preparing a few things for you... In the meantime, enjoy the scenery",
      delete: 'Are you sure you want to delete this {resource}?',
      password_not_required: 'Only include a password here if you want to set or change it.',
      automatic_unit_ordering: 'If Automatic Unit Ordering is checked, the assigned units will be applied to this clients budget every month, until Automatic Unit Ordering is turned off. If any month has a one-off order amount placed in it, the recurring amount will not be applied.',
      rank: 'Fetch the ranking for this keyword according to your set schedule.',
      report: 'Include this keyword in the domains report.',
      promote: 'Identify which keywords are currently being targeted for this domain. These are the only ones users will see when fulfilling units.',
      multiple_keywords: 'Enter multiple keywords at once by separating them with a comma.',
      add_keyword: 'Add keyword to this clients target keywords.',
      unit_record_discussion_label: 'Discussion on {client} {type} record',
      discussion_toggle: 'Toggle the discussion window between floating and fixed.',
      discussion_close: 'Close and remove this discussion from your open discussion list.',
      client_alert: 'Text here will appear along with the client name around SEOm, use it to convey important information that should be known about the client.',
      type_comment: 'Type your comment here...',
      domain_association: 'In most cases you would select Primary Domain. In situations where websites run across multiple domains you could set the domain as a child.',
      domain_url: "For this domain to successfully connect to your analytics and for accurate ranking to be retrieved, the URL needs to be identical to the final domain address. This includes www and https precision, like 'https://clientdomain.com' versus 'www.clientdomain.com'. Use whichever format is indexed by Search Engines.",
      simple_loading: 'Loading {resource}',
      loading: 'Loading {count} {resource} from page {page}',
      loading_with_year: 'Loading {resource} from {year}',
      loading_with_month: 'Loading {resource} from {month}',
      report_subject: '{date} SEO Report for {client}',
      uploading_image: 'Uploading Image',
      offline: "You're currently offline, you will only have access to some services in the app",
      analytics: {
        connect: 'Get Traffic Analytics',
        content: 'Connect to your analytics software to import this clients traffic, leads and revenue.'
      },
      keywords: {
        connect: 'Get Keyword Data',
        content: 'Connect your keyword analytics software to import keyword clicks and impressions for this domain.',
        add_user: "Add <b>one</b> of the following email address as a user to this domain's Google Search Console account with 'Restricted' access, and then click next."
      }
    },
    pagination: {
      previous: '&laquo; Previous',
      next: 'Next &raquo;'
    },
    passwords: {
      reset: 'Your password has been reset!',
      sent: 'We have emailed your password reset link!',
      throttled: 'Please wait before retrying.',
      token: 'This password reset token is invalid.',
      user: "We can't find a user with that email address."
    },
    permits: {
      settings: 'Settings',
      users: 'Account Users',
      roles: 'Account Roles'
    },
    report: {
      type: {
        adwords: 'Adwords',
        articles: 'Articles',
        blog: 'Blog Posts',
        comment: 'Comments',
        consultation: 'Consultation',
        directories: 'Directories',
        forum: 'Forum Posts',
        google_business: 'Google My Business Listing',
        infographic: 'Infographic',
        internal: 'Internal SEO',
        outreach: 'Outreach',
        press_release: 'Press Releases',
        profile: 'Profiles'
      },
      text: {
        title: '{date} SEO Report',
        client_visits: '{client} Visits: {count}',
        client_leads: '{client} Leads: {count}',
        google_rankings: 'Google Rankings as at {date}',
        visitor_keywords: 'Keywords used by visitors',
        typos: 'Typos & spelling mistakes are an exact representation of what searchers typed',
        search_visits: 'Visits from non-paid search engines: {count}',
        paid_visits: 'Visits from paid search engines: {count}',
        referring_visits: 'Visits from referring sites: {count}',
        direct_visits: 'Visits from direct traffic: {count}',
        social_visits: 'Visits from social traffic: {count}',
        email_visits: 'Visits from email traffic: {count}',
        seo: 'SEO: {count}',
        paid: 'Paid: {count}',
        referral: 'Referral: {count}',
        direct: 'Direct: {count}',
        social: 'Social: {count}',
        email: 'Email: {count}',
        total_lead_rate: 'Lead Rate:',
        seo_lead_rate: 'SEO Lead Rate:',
        paid_lead_rate: 'Paid Lead Rate:',
        referral_lead_rate: 'Referral Lead Rate:',
        direct_lead_rate: 'Direct Lead Rate:',
        social_lead_rate: 'Social Lead Rate:',
        email_lead_rate: 'Email Lead Rate:',
        maintained: 'maintained',
        google_maps: 'Google Maps',
        was: 'was'
      }
    },
    validation: {
      accepted: 'The {attribute} must be accepted.',
      active_url: 'The {attribute} is not a valid URL.',
      after: 'The {attribute} must be a date after {date}.',
      after_or_equal: 'The {attribute} must be a date after or equal to {date}.',
      alpha: 'The {attribute} may only contain letters.',
      alpha_dash: 'The {attribute} may only contain letters, numbers, dashes and underscores.',
      alpha_num: 'The {attribute} may only contain letters and numbers.',
      array: 'The {attribute} must be an array.',
      before: 'The {attribute} must be a date before {date}.',
      before_or_equal: 'The {attribute} must be a date before or equal to {date}.',
      between: {
        numeric: 'The {attribute} must be between {min} and {max}.',
        file: 'The {attribute} must be between {min} and {max} kilobytes.',
        string: 'The {attribute} must be between {min} and {max} characters.',
        array: 'The {attribute} must have between {min} and {max} items.'
      },
      boolean: 'The {attribute} field must be true or false.',
      confirmed: 'The {attribute} confirmation does not match.',
      date: 'The {attribute} is not a valid date.',
      date_equals: 'The {attribute} must be a date equal to {date}.',
      date_format: 'The {attribute} does not match the format {format}.',
      different: 'The {attribute} and {other} must be different.',
      digits: 'The {attribute} must be {digits} digits.',
      digits_between: 'The {attribute} must be between {min} and {max} digits.',
      dimensions: 'The {attribute} has invalid image dimensions.',
      distinct: 'The {attribute} field has a duplicate value.',
      email: 'The {attribute} must be a valid email address.',
      ends_with: 'The {attribute} must end with one of the following: {values}.',
      exists: 'The selected {attribute} is invalid.',
      file: 'The {attribute} must be a file.',
      filled: 'The {attribute} field must have a value.',
      gt: {
        numeric: 'The {attribute} must be greater than {value}.',
        file: 'The {attribute} must be greater than {value} kilobytes.',
        string: 'The {attribute} must be greater than {value} characters.',
        array: 'The {attribute} must have more than {value} items.'
      },
      gte: {
        numeric: 'The {attribute} must be greater than or equal {value}.',
        file: 'The {attribute} must be greater than or equal {value} kilobytes.',
        string: 'The {attribute} must be greater than or equal {value} characters.',
        array: 'The {attribute} must have {value} items or more.'
      },
      image: 'The {attribute} must be an image.',
      in: 'The selected {attribute} is invalid.',
      in_array: 'The {attribute} field does not exist in {other}.',
      integer: 'The {attribute} must be an integer.',
      ip: 'The {attribute} must be a valid IP address.',
      ipv4: 'The {attribute} must be a valid IPv4 address.',
      ipv6: 'The {attribute} must be a valid IPv6 address.',
      json: 'The {attribute} must be a valid JSON string.',
      lt: {
        numeric: 'The {attribute} must be less than {value}.',
        file: 'The {attribute} must be less than {value} kilobytes.',
        string: 'The {attribute} must be less than {value} characters.',
        array: 'The {attribute} must have less than {value} items.'
      },
      lte: {
        numeric: 'The {attribute} must be less than or equal {value}.',
        file: 'The {attribute} must be less than or equal {value} kilobytes.',
        string: 'The {attribute} must be less than or equal {value} characters.',
        array: 'The {attribute} must not have more than {value} items.'
      },
      max: {
        numeric: 'The {attribute} may not be greater than {max}.',
        file: 'The {attribute} may not be greater than {max} kilobytes.',
        string: 'The {attribute} may not be greater than {max} characters.',
        array: 'The {attribute} may not have more than {max} items.'
      },
      mimes: 'The {attribute} must be a file of type: {values}.',
      mimetypes: 'The {attribute} must be a file of type: {values}.',
      min: {
        numeric: 'The {attribute} must be at least {min}.',
        file: 'The {attribute} must be at least {min} kilobytes.',
        string: 'The {attribute} must be at least {min} characters.',
        array: 'The {attribute} must have at least {min} items.'
      },
      not_in: 'The selected {attribute} is invalid.',
      not_regex: 'The {attribute} format is invalid.',
      numeric: 'The {attribute} must be a number.',
      password: 'The password is incorrect.',
      present: 'The {attribute} field must be present.',
      regex: 'The {attribute} format is invalid.',
      required: 'The {attribute} field is required.',
      required_if: 'The {attribute} field is required when {other} is {value}.',
      required_unless: 'The {attribute} field is required unless {other} is in {values}.',
      required_with: 'The {attribute} field is required when {values} is present.',
      required_with_all: 'The {attribute} field is required when {values} are present.',
      required_without: 'The {attribute} field is required when {values} is not present.',
      required_without_all: 'The {attribute} field is required when none of {values} are present.',
      same: 'The {attribute} and {other} must match.',
      size: {
        numeric: 'The {attribute} must be {size}.',
        file: 'The {attribute} must be {size} kilobytes.',
        string: 'The {attribute} must be {size} characters.',
        array: 'The {attribute} must contain {size} items.'
      },
      starts_with: 'The {attribute} must start with one of the following: {values}.',
      string: 'The {attribute} must be a string.',
      timezone: 'The {attribute} must be a valid zone.',
      unique: 'The {attribute} has already been taken.',
      uploaded: 'The {attribute} failed to upload.',
      url: 'The {attribute} format is invalid.',
      uuid: 'The {attribute} must be a valid UUID.',
      custom: {
        'attribute-name': {
          'rule-name': 'custom-message'
        }
      },
      attributes: []
    }
  }
}
